var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "itmExtras noselect", class: { myLight: _vm.bgLight } },
    [
      _c(
        "v-layout",
        { staticStyle: { "margin-bottom": "0" } },
        [
          _c("v-flex", { attrs: { xs12: "", md8: "" } }, [
            _c(
              "div",
              {},
              [
                _vm.hasKennzeichnung &&
                (_vm.allImages.length === 0 ||
                  (_vm.imgSource.includes("placeholde") &&
                    !_vm.$store.state.showPlaceholders))
                  ? _c("div", {
                      staticClass: "spacer-15",
                      staticStyle: { height: "40px" },
                    })
                  : _vm._e(),
                _vm.hasKennzeichnung
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "badge" },
                        _vm._l(_vm.badges, function (badge) {
                          return _c("img", {
                            staticClass: "mr-2",
                            attrs: { src: badge.src },
                          })
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "v-container",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _vm.item.buyable &&
                        (_vm.item.sizes.length > 0 ||
                          _vm.hasExtras ||
                          _vm.hasVariants)
                          ? _c(
                              "v-flex",
                              {
                                staticStyle: { "padding-top": "0" },
                                attrs: { xs12: "" },
                              },
                              [
                                _vm.item.sizes && _vm.item.sizes.length > 1
                                  ? _c("div", [
                                      _c("h4", [_vm._v("Wähle deine Größe")]),
                                      _c(
                                        "div",
                                        { staticClass: "n-marge" },
                                        _vm._l(_vm.item.sizes, function (size) {
                                          return _c(
                                            "v-chip",
                                            {
                                              staticClass: "ma-2",
                                              attrs: {
                                                "active-class": "primary",
                                                "input-value":
                                                  _vm.currentVol === size.vol,
                                              },
                                              nativeOn: {
                                                "&click": function ($event) {
                                                  return _vm.switchSize(
                                                    size.vol
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-avatar",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.currentVol ===
                                                        size.vol,
                                                      expression:
                                                        "currentVol === size.vol",
                                                    },
                                                  ],
                                                  attrs: { left: "" },
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("mdi-check"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("sizeDisplay")(size)
                                                  ) +
                                                  " "
                                              ),
                                              !_vm.$store.getters.hidePrices
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("price")(
                                                          size.price
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.hasExtras && _vm.loaded
                                  ? _c("div", { staticClass: "pt-3 fade-in" }, [
                                      _c("h4", { attrs: { id: "extras" } }, [
                                        _vm._v("Deine Extras:"),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "n-marge" },
                                        _vm._l(
                                          _vm.item.extras.styles,
                                          function (extra) {
                                            return _c(
                                              "v-chip",
                                              {
                                                staticClass: "ma-1",
                                                attrs: {
                                                  "input-value":
                                                    extra.aaaSelected,
                                                  "active-class": "primary",
                                                },
                                                nativeOn: {
                                                  "&click": function ($event) {
                                                    return _vm.switchExtra(
                                                      extra
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-avatar",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          extra.aaaSelected,
                                                        expression:
                                                          "extra.aaaSelected",
                                                      },
                                                    ],
                                                    attrs: { left: "" },
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("mdi-check"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      extra.labelDE
                                                    ),
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _vm.getExtraCost(extra) > 0
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "ml-1" },
                                                      [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              _vm._f(
                                                                "displayExtraPrice"
                                                              )(
                                                                extra,
                                                                _vm.currentVol
                                                              )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.hasVariants && _vm.loaded
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "pt-3 fade-in",
                                        attrs: { id: "variants" },
                                      },
                                      [
                                        _vm._l(
                                          _vm.item.extras.variants,
                                          function (variant, index) {
                                            return _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: variant.show,
                                                    expression: "variant.show",
                                                  },
                                                ],
                                                attrs: { id: variant.aaaIndex },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "variants" },
                                                  [
                                                    index > 0
                                                      ? _c("div", {
                                                          staticClass:
                                                            "spacer-15",
                                                        })
                                                      : _vm._e(),
                                                    variant.dropdown
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center bigger-input",
                                                          },
                                                          [
                                                            !variant.ext
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        flex: "0 0 40%",
                                                                      },
                                                                  },
                                                                  [
                                                                    variant.title &&
                                                                    variant.title.indexOf(
                                                                      "<"
                                                                    ) !== -1
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    variant.title
                                                                                  ),
                                                                              },
                                                                          }
                                                                        )
                                                                      : _c(
                                                                          "h4",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                variant.title
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "div",
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          dark: !_vm.bgLight,
                                                                        },
                                                                        nativeOn:
                                                                          {
                                                                            "&click":
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.removeExtraPortion(
                                                                                  index,
                                                                                  variant.aaaIndex
                                                                                )
                                                                              },
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-close-thick "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  flex: "0 0 60%",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "prelative",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-select",
                                                                      {
                                                                        staticClass:
                                                                          "ml-4",
                                                                        staticStyle:
                                                                          {
                                                                            "padding-top":
                                                                              "0",
                                                                            "max-width":
                                                                              "50vw",
                                                                          },
                                                                        attrs: {
                                                                          dark: !_vm.bgLight,
                                                                          outlined:
                                                                            "",
                                                                          items:
                                                                            variant.options,
                                                                          "item-text":
                                                                            "aaaDisplayLabel",
                                                                          "item-value":
                                                                            "id",
                                                                          "return-object":
                                                                            "",
                                                                          "single-line":
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          input:
                                                                            _vm.selectDropdOption,
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.changeVariant(
                                                                                variant,
                                                                                index
                                                                              )
                                                                            },
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "item",
                                                                                fn: function (
                                                                                  data
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        domProps:
                                                                                          {
                                                                                            innerHTML:
                                                                                              _vm._s(
                                                                                                data
                                                                                                  .item
                                                                                                  .aaaDisplayLabel
                                                                                              ),
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                              {
                                                                                key: "selection",
                                                                                fn: function (
                                                                                  data
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "oneLiner",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "b",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm._f(
                                                                                                  "displayOptionWithoutSplits"
                                                                                                )(
                                                                                                  data.item
                                                                                                )
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                        data
                                                                                          .item
                                                                                          .cost
                                                                                          ? _c(
                                                                                              "span",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "(" +
                                                                                                    _vm._s(
                                                                                                      _vm._f(
                                                                                                        "displayOptionPrice"
                                                                                                      )(
                                                                                                        data
                                                                                                          .item
                                                                                                          .cost,
                                                                                                        !!variant.replaceArticle
                                                                                                      )
                                                                                                    ) +
                                                                                                    ")"
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e(),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .selectModels[
                                                                              "sm" +
                                                                                index
                                                                            ],
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.selectModels,
                                                                                "sm" +
                                                                                  index,
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "selectModels['sm'+index]",
                                                                        },
                                                                      }
                                                                    ),
                                                                    !_vm
                                                                      .selectModels[
                                                                      "sm" +
                                                                        index
                                                                    ] ||
                                                                    _vm
                                                                      .selectModels[
                                                                      "sm" +
                                                                        index
                                                                    ].id === ""
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "absSelects",
                                                                            class:
                                                                              {
                                                                                bgLight:
                                                                                  _vm.bgLight,
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "superCenter",
                                                                              },
                                                                              [
                                                                                variant.optional
                                                                                  ? _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "optional wählbar"
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "bitte wählen"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                            _c("div"),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          [
                                                            variant.title &&
                                                            variant.title.indexOf(
                                                              "<"
                                                            ) !== -1
                                                              ? _c("div", {
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        variant.title
                                                                      ),
                                                                  },
                                                                })
                                                              : _c("h4", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      variant.title
                                                                    )
                                                                  ),
                                                                ]),
                                                            _vm._l(
                                                              variant.options,
                                                              function (
                                                                option
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "option pointer",
                                                                    class: {
                                                                      selected:
                                                                        option.aaaSelected,
                                                                    },
                                                                    on: {
                                                                      "&click":
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.selectOption(
                                                                            variant,
                                                                            option
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "d-flex",
                                                                      },
                                                                      [
                                                                        variant.multi
                                                                          ? _c(
                                                                              "div",
                                                                              [
                                                                                option.aaaSelected
                                                                                  ? _c(
                                                                                      "v-icon",
                                                                                      [
                                                                                        _vm._v(
                                                                                          " mdi-check-box-outline "
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _c(
                                                                                      "v-icon",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "mdi-checkbox-blank-outline"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _c(
                                                                              "div",
                                                                              [
                                                                                option.aaaSelected
                                                                                  ? _c(
                                                                                      "v-icon",
                                                                                      [
                                                                                        _vm._v(
                                                                                          " mdi-check-circle-outline "
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _c(
                                                                                      "v-icon",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "mdi-checkbox-blank-circle-outline "
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "fasterGrow",
                                                                            staticStyle:
                                                                              {
                                                                                "padding-left":
                                                                                  "3%",
                                                                              },
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    option.labelDE
                                                                                  ),
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "v-spacer"
                                                                        ),
                                                                        !_vm
                                                                          .item
                                                                          .extras
                                                                          .combinations
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    float:
                                                                                      "right",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      _vm._f(
                                                                                        "displayOptionPrice"
                                                                                      )(
                                                                                        option.cost,
                                                                                        !!variant.replaceArticle
                                                                                      )
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        !_vm
                                                                          .$store
                                                                          .getters
                                                                          .hidePrices &&
                                                                        _vm.item
                                                                          .extras
                                                                          .combinations &&
                                                                        _vm.item
                                                                          .extras
                                                                          .variants
                                                                          .length ===
                                                                          1
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    float:
                                                                                      "right",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    class:
                                                                                      {
                                                                                        oprice:
                                                                                          _vm.item.extras.combinations.find(
                                                                                            (
                                                                                              c
                                                                                            ) =>
                                                                                              c.id ===
                                                                                              option.id
                                                                                          )
                                                                                            .streichPreis,
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm._f(
                                                                                          "price"
                                                                                        )(
                                                                                          _vm.item.extras.combinations.find(
                                                                                            (
                                                                                              c
                                                                                            ) =>
                                                                                              c.id ===
                                                                                              option.id
                                                                                          )
                                                                                            .price
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm.item.extras.combinations.find(
                                                                                  (
                                                                                    c
                                                                                  ) =>
                                                                                    c.id ===
                                                                                    option.id
                                                                                )
                                                                                  .streichPreis
                                                                                  ? _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "streichPreisCrossed ml-2",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm._f(
                                                                                              "price"
                                                                                            )(
                                                                                              _vm.item.extras.combinations.find(
                                                                                                (
                                                                                                  c
                                                                                                ) =>
                                                                                                  c.id ===
                                                                                                  option.id
                                                                                              )
                                                                                                .streichPreis
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            variant.optional &&
                                                            !variant.implicit
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "option pointer d-flex",
                                                                    class: {
                                                                      selected:
                                                                        variant.aaaOhne,
                                                                    },
                                                                    on: {
                                                                      "&click":
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.selectOhne(
                                                                            variant
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    variant.aaaOhne
                                                                      ? _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-check-circle-outline"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-checkbox-blank-circle-outline"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "padding-left":
                                                                              "3%",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "ohne"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                    variant.extendable &&
                                                    variant.showExtraPortion
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mt-3 mb-1 headColor",
                                                            staticStyle: {
                                                              "font-size":
                                                                "1.2em",
                                                            },
                                                            on: {
                                                              "&click":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.addExtraPortion(
                                                                    variant.aaaIndex,
                                                                    index
                                                                  )
                                                                },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "btn-mini",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+ Extra Portion"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _c("div", { staticClass: "spacer" }),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm.buyable && _vm.loaded
                          ? _c(
                              "v-flex",
                              { staticClass: "fade-in", attrs: { xs12: "" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-shrink-0 align-self-center",
                                      },
                                      [
                                        !_vm.item.unikat
                                          ? _c("table", [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "counterStuff minus",
                                                    on: {
                                                      "&click": function (
                                                        $event
                                                      ) {
                                                        return _vm.clickMinus.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      class: {
                                                        invertImg: !_vm.bgLight,
                                                      },
                                                      attrs: {
                                                        src: require("../assets/icons/item-minus.png"),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  { staticClass: "counter" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.multiplicator)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "counterStuff",
                                                    on: {
                                                      "&click": function (
                                                        $event
                                                      ) {
                                                        return _vm.clickPlus.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      class: {
                                                        invertImg: !_vm.bgLight,
                                                      },
                                                      attrs: {
                                                        src: require("../assets/icons/item-plus.png"),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm.item.sizes && _vm.item.sizes.length > 0
                                      ? _c("add-to-cart-button", {
                                          staticClass: "ml-3",
                                          attrs: {
                                            total: _vm.fulltotal,
                                            noblink: _vm.noblink,
                                            small: true,
                                          },
                                          nativeOn: {
                                            "&click": function ($event) {
                                              return _vm.addToCart.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.$store.state.enableItemNote &&
                        _vm.buyable &&
                        _vm.loaded
                          ? _c(
                              "v-flex",
                              { staticClass: "fade-in", attrs: { xs12: "" } },
                              [
                                _c("v-text-field", {
                                  staticClass: "nolabel panelField pt-4",
                                  attrs: {
                                    placeholder: "Anmerkung",
                                    illed: "",
                                    "hide-details": "",
                                    outlined: "",
                                    clearable: "",
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.item.notes,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.item, "notes", $$v)
                                    },
                                    expression: "item.notes",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-flex",
                          { attrs: { x12: "" } },
                          [
                            !_vm.item.ticket
                              ? _c(
                                  "v-expansion-panels",
                                  {
                                    staticClass: "panels forceTextWrap",
                                    staticStyle: { "overflow-x": "hidden" },
                                  },
                                  [
                                    _vm.item.inhaltsstoffe
                                      ? _c(
                                          "v-expansion-panel",
                                          { key: "1" },
                                          [
                                            _c("v-expansion-panel-header", [
                                              _vm._v("Inhaltsstoffe"),
                                            ]),
                                            _c("v-expansion-panel-content", [
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.spacify(
                                                      _vm.item.inhaltsstoffe
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.item.nutritions
                                      ? _c(
                                          "v-expansion-panel",
                                          { key: "2" },
                                          [
                                            _c("v-expansion-panel-header", [
                                              _vm._v("Nährwerte"),
                                            ]),
                                            _c("v-expansion-panel-content", [
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.item.nutritions
                                                  ),
                                                },
                                              }),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-expansion-panel",
                                      { key: "3" },
                                      [
                                        _c("v-expansion-panel-header", [
                                          _vm._v("Allergene & Zusatzstoffe "),
                                        ]),
                                        _vm.combinedAllergene
                                          ? _c(
                                              "v-expansion-panel-content",
                                              [
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.combinedAllergene
                                                    ),
                                                  },
                                                }),
                                                _vm.combinedAllergene &&
                                                _vm.combinedAllergene.indexOf(
                                                  "<sup>"
                                                ) !== -1
                                                  ? _c("AllergenLegende")
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _c("v-expansion-panel-content", [
                                              _vm._v(
                                                "Dieser Artikel enthält keine Angaben zu Allergenen und Zusatzstoffen "
                                              ),
                                            ]),
                                      ],
                                      1
                                    ),
                                    _vm._l(
                                      _vm.item.merkmalgruppen,
                                      function (mg, index) {
                                        return _vm.item.merkmalgruppen
                                          ? _c(
                                              "v-expansion-panel",
                                              { key: index + 4 },
                                              [
                                                _c("v-expansion-panel-header", [
                                                  _vm._v(_vm._s(mg.name)),
                                                ]),
                                                _c(
                                                  "v-expansion-panel-content",
                                                  [
                                                    _vm.hasOnlyKeys(
                                                      mg.keyValues
                                                    )
                                                      ? _c(
                                                          "div",
                                                          _vm._l(
                                                            mg.keyValues,
                                                            function (kv) {
                                                              return _c("div", [
                                                                _vm._v(
                                                                  _vm._s(kv.key)
                                                                ),
                                                              ])
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _vm._l(
                                                          mg.keyValues,
                                                          function (kv) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        flex: "1 1 50%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        class: {
                                                                          "pl-3":
                                                                            kv.params &&
                                                                            kv
                                                                              .params
                                                                              .indent,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            kv.key
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        flex: "1 1 50%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        kv.value
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.item.buyable && _vm.showWeiter
                              ? _c("div", { staticClass: "pt-5" }, [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "ml-3 btn-df okBtn text-none",
                                          nativeOn: {
                                            "&click": function ($event) {
                                              return _vm.goCart.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(" Zum Korb "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { right: "", medium: "" },
                                            },
                                            [_vm._v(" mdi-chevron-right ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm.itemClone
                              ? _c(
                                  "div",
                                  [
                                    _c("ItemDetailsTabs", {
                                      attrs: { item: _vm.itemClone },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }